export enum ProductSource {
  Local = 1,
  Karbari = 2,
  Woocommerce = 3,
  EcomDrive = 4,
  Nuport = 5,
  BizMotion = 6,
  Shopify = 7,
}

export const ProductSourceLabels: Record<ProductSource, string> = {
  [ProductSource.Local]: "Local",
  [ProductSource.Karbari]: "Karbari",
  [ProductSource.Woocommerce]: "WooCommerce",
  [ProductSource.EcomDrive]: "EcomDrive",
  [ProductSource.Nuport]: "Nuport",
  [ProductSource.BizMotion]: "BizMotion",
  [ProductSource.Shopify]: "Shopify",
};

export const ProductSourceValues: Record<string, ProductSource> = {
  local: ProductSource.Local,
  karbari: ProductSource.Karbari,
  woocommerce: ProductSource.Woocommerce,
  ecomdrive: ProductSource.EcomDrive,
  nuport: ProductSource.Nuport,
  bizmotion: ProductSource.BizMotion,
  shopify: ProductSource.Shopify,
};
